<template>
    <form class="border mt-2 p-2" @submit.prevent="submit">
        <div class="d-flex justify-content-around align-items-center" style="gap: 0.25rem">
            <div class="d-flex flex-column w-100" style="gap: 0.25rem">
                <p class="d-flex align-items-center m-0">
                    <span class="text-right" style="width: 15%">Add&nbsp;</span>
                    <v-select
                        class="w-100"
                        placeholder="Device..."
                        v-model="selected_device"
                        :options="devices_for_dropdown"
                    ></v-select>
                </p>
                <p class="d-flex align-items-center m-0">
                    <span class="text-right" style="width: 15%">To&nbsp;</span>
                    <v-select
                        class="w-100"
                        placeholder="Zone..."
                        v-model="selected_zone"
                        :options="zones_for_dropdown"
                    ></v-select>
                </p>
            </div>
            <button type="submit" class="btn btn-secondary">Add</button>
        </div>
    </form>
</template>

<script>
import vSelect from 'vue-select';
import { DEVICE_TYPE, ZONE_TYPE } from '../../../assets/js/resource-types';

export default {
    props: {
        devices: Array,
        zones: Array,
        callback: Function
    },
    components: { vSelect },
    data() {
        return {
            selected_device: null,
            selected_zone: null
        }
    },
    computed: {
        devices_for_dropdown() {
            if(!this.selected_zone)
                return this.devices.map(device => ({ label: device.name, value: device }));

            return this.devices
                .filter(device => this.selected_zone_type_id === ZONE_TYPE.Visual ? device.device_type_id === DEVICE_TYPE.Visual : device.device_type_id !== DEVICE_TYPE.Visual)
                .map(device => ({ label: device.name, value: device }))
        },
        zones_for_dropdown() {
            if(!this.selected_device)
                return this.zones.map(zone => ({ label: zone.name, value: zone }));

            return this.zones
                .filter(zone => this.selected_device_type_id === DEVICE_TYPE.Visual ? zone.zone_type_id === ZONE_TYPE.Visual : zone.zone_type_id !== ZONE_TYPE.Visual)
                .map(zone => ({ label: zone.name, value: zone }));
        },
        selected_device_type_id() {
            if(!this.selected_device) return null;
            return this.selected_device.value.device_type_id
        },
        selected_zone_type_id() {
            if(!this.selected_zone) return null;
            return this.selected_zone.value.zone_type_id;
        }
    },
    methods: {
        submit() {
            if(!this.selected_device || !this.selected_zone) return;

            const device = this.selected_device.value;
            const zone = this.selected_zone.value;
            
            zone.zone_devices.push({
                device_id: device.device_id,
                zone_id: zone.zone_id,
                device: {
                    name: device.name,
                    device_type_id: device.device_type_id,
                    site_id: device.site_id,
                    site: {
                        name: device.site.name
                    }
                }
            });

            this.$store.dispatch('assignDevices', zone).then(() => {
                this.selected_device = null;
                this.selected_zone = null;
                if(this.callback) this.callback(device.name, zone.name);
            });
        }
    }
}
</script>